<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
  <div class="form-horizontal">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group row">
          <div class="col-md-12">
            <yt-dropdown-picklist
              [ModelName]="'komitent'"
              [GetName]="'get'"
              [ModelProperty]="'SNaziv,Mesto'"
              [OrderBy]="'SNaziv'"
              [AllowAddNew]="true"
              [AllowEdit]="true"
              formControlName="KomitentID"
              [Label]="'KOMITENTKONTAKTOSOBA.KOMITENT.SINGULAR'"
              [Width]="'150%'"
              [Position]="'left'"
              [ngClass]="{ 'is-invalid': submitted && fc.KomitentID.invalid }"
              #cmbKomitent
            >
            </yt-dropdown-picklist>
            
          </div>
        </div>

        <div class="form-group row">
          <div class="col-md-12">
            <yt-dropdown-picklist
              [ModelName]="'osoba'" 
              [GetName]="'get'" 
              [ModelProperty]="'Prezime,Ime,Jmbg'" 
              [OrderBy]="'Prezime'"
              [AllowAddNew]="true" 
              [AllowEdit]="true"
              formControlName="OsobaID" 
              [Label]="'KOMITENTKONTAKTOSOBA.OSOBA.SINGULAR'"
              [Width]="'800px'"
              [Position]="'left'"
              [Required]="false"
              [ngClass]="{'is-invalid': submitted && fc.OsobaID.invalid}"
              #cmbOsoba
              >
            </yt-dropdown-picklist>
            
          </div>
        </div>
        
       
        <div class="form-group row" >
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              name="txtOpis"
              formControlName="Opis"
              [MaxLength]="250"
              [Label]="'KOMITENTKONTAKTOSOBA.OPIS.SINGULAR'"
            >
            </yt-input>
          </div>
        </div>

        
      </div>
    </div>
  </div>
</form>
